




















































































































































































































































































































































































































































































































import { WeekDaysEnum } from "@/lib/enum/weekDays.enum";
import { emailRule, extendetPhoneRule } from "@/lib/rules/contactRule";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import {
  MrfiktivGooglePlaceDtoGen,
  MrfiktivInboxDtoGen,
  MrfiktivPartnerSettingsDocumentGen,
  MrfiktivPartnerSettingsDtoGen,
  MrfiktivPartnerViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { CreatePartnerSettingsDto } from "@/store/models/mrfiktiv/partner-settings";
import { Component, Prop, Watch } from "vue-property-decorator";
import PartnerCreateOrUpdateLandingpageSettigns from "./PartnerCreateOrUpdateLandingpageSettigns.vue";
import PartnerCreateOrUpdateLicense from "./PartnerCreateOrUpdateLicense.vue";
import PartnerCreateOrUpdateReportSettings from "./PartnerCreateOrUpdateReportSettings.vue";
import { requiredRule } from "@/lib/rules/requiredRule";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import CustomFieldBoolean from "@/components/report/CustomFieldBoolean.vue";
import { DamageTypeEnum } from "@/store/enum/damage-type.enum";
import aiService from "@/services/mrfiktiv/services/aiService";
import { handleError } from "@/lib/utility/handleError";
import { debounce } from "debounce";
import { AppColorConfig, AppColorTheme } from "@/store/models/mrfiktiv/color-theme";

@Component({
  components: {
    ConfirmActionDialog,
    PartnerCreateOrUpdateLandingpageSettigns,
    PartnerCreateOrUpdateReportSettings,
    PartnerCreateOrUpdateLicense,
    CustomFieldBoolean
  }
})
export default class PartnerSettingsForm extends DarkModeHighlightMixin {
  DamageTypeEnum = DamageTypeEnum;
  tab = 0;

  @Prop()
  partner!: MrfiktivPartnerViewModelGen;

  @Prop()
  settings!: MrfiktivPartnerSettingsDocumentGen;

  @Prop({ default: false })
  isLoading!: boolean;

  search: string | null = "";

  place: MrfiktivGooglePlaceDtoGen | null = null;
  googlePlaceRes: MrfiktivGooglePlaceDtoGen[] = [];
  isGoogleLoading = false;

  newInbox: MrfiktivInboxDtoGen = {
    source: "email", //TODO add enum
    name: "",
    identifier: "",
    isActive: false
  };

  weekDays = Object.keys(WeekDaysEnum).map(k => WeekDaysEnum[k as any]);

  disabled = true;

  valid = false;

  isUpdateInboxesValid = false;

  update: MrfiktivPartnerSettingsDtoGen = new CreatePartnerSettingsDto(this.settings);

  debounceSearchPlace = debounce(this.getPlace, 1000, false);

  @Watch("search")
  async watchSearch() {
    this.debounceSearchPlace();
  }

  @Watch("place")
  watchPlace() {
    if (!this.place) {
      return;
    }

    this.update.placeId = this.place.id;
    this.update.googleMapsUri = this.place?.googleMapsUri;
  }

  get isLightPalette(): boolean {
    if (
      this.update &&
      this.update.themes &&
      this.update.themes.light &&
      Array.isArray(this.update.themes.light.palette)
    ) {
      return true;
    }
    return false;
  }

  get requiredRule() {
    return [requiredRule()];
  }

  get mailRule() {
    return [requiredRule(), emailRule()];
  }

  isAddUpdateInboxesDialogActive = false;

  mounted() {
    this.initialize();
  }

  initialize() {
    this.update = new CreatePartnerSettingsDto(this.settings);
    this.search = `${this.partner.companyName} ${this.partner.address?.street} ${this.partner.address?.zip} ${this.partner.address?.city} ${this.partner.address?.state}`;
    if (!this.place && !this.update.placeId) {
      this.getPlace();
    }
  }

  getAvatarColor(hex: string | undefined): string {
    return hex && hex.trim() !== "" ? hex : "grey lighten-2";
  }

  addNewInbox() {
    if (!this.update.inboxes) {
      this.update.inboxes = [];
    }

    this.update.inboxes.push(this.newInbox);
    this.newInbox = {
      source: "email", //TODO add enum
      name: "",
      identifier: "",
      isActive: false
    };
    this.isAddUpdateInboxesDialogActive = false;
  }

  save(): MrfiktivPartnerSettingsDtoGen {
    this.$emit("save", this.update);
    this.disabled = true;

    return this.update;
  }

  /**
   *
   */
  addColorTheme() {
    this.update.themes = new AppColorConfig({ light: new AppColorTheme({ palette: ["#0000FF"] }) });
  }

  /**
   * ensure light palette is defined
   */
  private ensureLightThemeAndPalette() {
    if (!this.update.themes) {
      this.update.themes = new AppColorConfig();
    }
    if (!this.update.themes.light) {
      this.update.themes.light = new AppColorTheme({ palette: [] });
    }
    if (!Array.isArray(this.update.themes.light.palette)) {
      this.$set(this.update.themes.light, "palette", []);
    }
  }

  get isThemeColorClearable() {
    if (!this.update?.themes?.light?.palette) {
      return false;
    }
    return this.update.themes.light.palette.length > 1;
  }

  /**
   * Add new Color to palette
   */
  addPaletteColor() {
    this.ensureLightThemeAndPalette();
    if (!this.update?.themes?.light?.palette) {
      return;
    }
    this.update.themes.light.palette.push("");
  }

  /**
   * Remove an entry from the palette
   */
  splicePaletteColor(index: number) {
    if (this.update?.themes?.light?.palette && Array.isArray(this.update.themes.light.palette)) {
      this.update.themes.light.palette.splice(index, 1);
    }
  }

  /** Palette: Wert aktualisieren – analog updateTaxRate */
  updatePaletteColor(value: string, index: number) {
    if (this.update?.themes?.light?.palette && Array.isArray(this.update.themes.light.palette)) {
      this.$set(this.update.themes.light.palette, index, String(value));
    }
  }

  removeColorTheme() {
    this.update.themes = undefined;
  }

  abort() {
    this.initialize();
    this.disabled = true;
  }

  get emailRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(emailRule());

    return rules;
  }

  get phoneRules() {
    const rules = [];

    rules.push(extendetPhoneRule());

    return rules;
  }

  addTaxRate() {
    if (!this.update.taxRates) {
      return [0];
    }

    this.update.taxRates?.push(0);
  }

  spliceTaxRate(index: number) {
    if (Array.isArray(this.update.taxRates)) {
      this.update.taxRates.splice(index, 1);
    }
  }

  updateTaxRate(value: string | number, index: number) {
    if (Array.isArray(this.update.taxRates)) {
      this.$set(this.update.taxRates, index, Number(value));
    }
  }

  async getPlace() {
    if (!this.search) {
      return;
    }

    this.isGoogleLoading = true;
    this.$log.warn(this.search);
    try {
      this.googlePlaceRes = await aiService.locationControllerSearch({
        partnerId: this.partner.id,
        search: this.search
      });

      this.$log.debug(this.googlePlaceRes);
    } catch (error) {
      handleError(error);
    } finally {
      this.isGoogleLoading = false;
    }
  }
}
